<template>
  <div>
    <div v-if="!showContent">
      <div class="loading">
        Loading&#8230;
      </div>
    </div>
    <player v-if="showLetterAndVideo"></player>
    <div class="container" v-if="showContent" :class="containerClass">
      <div class="row">
        <div class="col-md-12" v-for="item in itemsSortable1">
          <keep-alive>
            <home-menu v-if="item.tipo === 'menu'" :bloco="item"></home-menu>
            <home-slides v-if="item.tipo === 'slider'" :bloco="item"></home-slides>
            <home-image-gallery-list v-if="item.tipo === 'capa'" :bloco="item"></home-image-gallery-list>
          </keep-alive>
        </div>
      </div>
      <router-multi-view v-if="showRouter"></router-multi-view>
      <div class="row" v-show="rotaAtual">
        <div class="col-xs-12 col-md-12">
          <div v-for="item in itemsSortable5">
            <keep-alive>
              <home-slides :is="" v-if="item.tipo === 'slider'" :bloco="item"></home-slides>
              <home-image-gallery-list v-if="item.tipo === 'capa'" :bloco="item"></home-image-gallery-list>
              <home-social-networks-list v-if="item.tipo === 'redesocial'" :bloco="item"></home-social-networks-list>
              <home-image-gallery-list v-if="item.tipo === 'imagem'" :bloco="item"></home-image-gallery-list>
              <home-publicity v-if="item.tipo === 'publicidade'" :bloco="item"></home-publicity>
              <home-menu v-if="item.tipo === 'menu'" :bloco="item"></home-menu>
              <home-album-list v-if="item.tipo === 'album'" :bloco="item"></home-album-list>
              <home-links v-if="item.tipo === 'links'" :bloco="item"></home-links>
            </keep-alive>
          </div>
        </div>
      </div>
      <div class="row rodape">
        <a :href="radioConfig.aparencia.builder.site_footer_name_link" :title="radioConfig.aparencia.builder.version"
           target="_blank"
           class="logo_max">{{ radioConfig.aparencia.builder.site_footer_name }}</a>
      </div>
    </div>
  </div>
</template>

<script>

  import {get} from './helpers/api';
  import HomeBlogList from './components/home/BlogList.vue';
  import HomeNowInRadioList from './components/home/NowInRadioList.vue';
  import HomePoll from './components/home/Poll.vue';
  import HomeDownloadApp from './components/home/DownloadApp.vue';
  import HomeSocialNetworksList from './components/home/SocialNetworksList.vue';
  import HomeTopMusicsList from './components/home/TopMusicsList.vue';
  import HomeImageGalleryList from './components/home/ImageGalleryList.vue';
  import HomeVideoGalleryList from './components/home/VideoGalleryList.vue';
  import HomeLocutorOnline from './components/home/LocutorOnline.vue';
  import HomeBanner from './components/home/Banner.vue';
  import HomeMessageBoards from './components/home/MessageBoards.vue';
  import HomeStatistics from './components/home/Statistics.vue';
  import HomeCalendar from './components/home/Calendar.vue';
  import HomeRequestMusic from './components/home/RequestMusic.vue';
  import HomePublicity from './components/home/Publicity.vue';
  import HomeMenu from './components/home/Menu.vue';
  import HomeAlbumList from './components/home/AlbumList.vue';
  import HomeSlides from './components/home/Slides.vue';
  import HomeMusics from './components/home/Musics.vue';
  import HomeLinks from './components/home/Links.vue';
  import HomeEvents from './components/home/Events.vue';
  import HomePromotions from './components/home/Promotions.vue';
  import Player from "./components/home/Player.vue";
  import VueScrollbar from 'vue2-scrollbar'
  import axios from 'axios';
  import {mapActions} from 'vuex'


  export default {
    components: {
      Player,
      HomeBlogList,
      HomeNowInRadioList,
      HomePoll,
      HomeDownloadApp,
      HomeSocialNetworksList,
      HomeTopMusicsList,
      HomeImageGalleryList,
      HomeVideoGalleryList,
      HomeLocutorOnline,
      HomeBanner,
      HomeMessageBoards,
      HomeStatistics,
      HomeCalendar,
      HomeRequestMusic,
      HomePublicity,
      HomeMenu,
      HomeAlbumList,
      HomeSlides,
      HomeMusics,
      HomeLinks,
      HomeEvents,
      HomePromotions,
      VueScrollbar
    },
    data() {
      return {
        itemsSortable1: [],
        itemsSortable5: [],
        showKeywords: false,
        metatags: [],
        siteKeywords: '',
        icon: '',
        siteTitleName: '',
        statisticCodGoogleAnalytics: '',
        css: '',
        siteDescription: '',
        sharedImage: '',
        showSite: 0,
        showLetterAndVideo: false,
        streaming: null,
        showRouter: false,
        radioConfig: {},
        playing: {},
      }
    },
    mounted() {
    },
    created() {
      let self = this;
      self.carregado = true;

      axios.get(window.config.API_URL + 'site-content?builder_id=' + window.config.BUILDER_ID).then(function (response) {
        self.setSiteContent(response.data)
        self.showSite++;
      });
      axios.get(window.config.API_URL + 'builder/' + window.config.BUILDER_ID).then(function (response) {
        //seta url current
        self.builderInfo(response.data)
        self.radioConfig = response.data;

        if (response.data.current) {
          // se existir radio
          axios.get(response.data.current).then(function (response) {
            self.currentInfo(response.data)
            self.playing = response.data;
            //se a radio esta onlione
            if (response.data.online) {
              if (response.data.song_data.video) {
                self.playing.song_data.video = "https://www.youtube.com/embed/" + response.data.song_data.video + "?rel=0&amp;controls=0&amp;showinfo=0&modestbranding=1&frameborder=0"
              } else {
                self.playing.song_data.video = null;
              }
            } else {
              // self.playing.song_data.video =  'gagre';
              self.playing = {
                song_data: {
                  video: null,
                  lyric: null,
                  cover: null,
                },
                playing: {
                  title: null,
                  name: null
                }
              }
            }
            self.showSite++;
            self.showLetterAndVideo = true;
          });
        } else {
          self.showSite++;
        }
      });
      axios.get(window.config.API_URL + 'social-links/?builder_id=' + window.config.BUILDER_ID).then(function (response) {
        self.setRedeSocial(response.data.result)
      });

      // metodo paga pegar informações da pagina
      get('head-info').then(function (response) {
        let siteConfigs = response.data.result.data;
        self.showKeywords = true;
        self.metatags = siteConfigs.metaTags;
        self.siteKeywords = siteConfigs.siteKeywords;
        self.icon = siteConfigs.icon;
        self.siteTitleName = siteConfigs.siteTitleName;
        self.statisticCodGoogleAnalytics = siteConfigs.statisticCodGoogleAnalytics;
        self.css = siteConfigs.css;
        self.siteDescription = siteConfigs.siteDescription;
        self.sharedImage = siteConfigs.sharedImage;
      });

      get('blocos-builder').then(function (response) {

        self.setBlocos(response.data.result.data);

        self.itemsSortable1 = self.$store.getters['getBlocos'].sortable1;
        self.itemsSortable5 = self.$store.getters['getBlocos'].sortable5;
        self.showRouter = true;
      });
      // });
    },
    methods: {
      ...mapActions(['builderInfo', 'currentInfo', 'setRedeSocial', 'setSiteContent', 'setBlocos']),
    },
    computed: {
      showContent() {
        if (this.showSite >= 2) {
          return true;
        }
        return false;
      },
      returnClassContainer: function () {
        if (this.radioConfig.aparencia.builder.player_position) {
          return "margin-bottom:80px"
        }
        return "margin-top:80px"
      },
      containerClass: function () {
        if (this.radioConfig.aparencia.builder.player_position) {
          return "container-bottom"
        }
        return "container-top"
      },
      configVars: function () {
        return window.config;
      },
      rotaAtual: function () {
        if (this.$route.name == 'index') {
          return true;
        }
        return false;
      },
    }
  }
</script>


<style>


  /* Absolute Center Spinner */
  .loading {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  /* Transparent Overlay */
  .loading:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  /* :not(:required) hides these rules from IE9 and below */
  .loading:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
  }

  .loading:not(:required):after {
    content: '';
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 1500ms infinite linear;
    -moz-animation: spinner 1500ms infinite linear;
    -ms-animation: spinner 1500ms infinite linear;
    -o-animation: spinner 1500ms infinite linear;
    animation: spinner 1500ms infinite linear;
    border-radius: 0.5em;
    -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
    box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  }

  /* Animation */

  @-webkit-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-moz-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-o-keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue